
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as cartX6bTwpaQBMteMr7h1lUk_45Hejw4o7uN9sNNgQWl4qa28Meta } from "/var/www/frontend/releases/20260721132756/pages/cart.vue?macro=true";
import { default as indexFdJnyX4yP6sZzkSjnsbesXglii3C3J2SWDdhv7Iv5JMMeta } from "/var/www/frontend/releases/20260721132756/pages/index.vue?macro=true";
import { default as search0goly6I4fYhpXrzDz_N9ouAk3HSrjnW3EDP9AXqlMtkMeta } from "/var/www/frontend/releases/20260721132756/pages/search.vue?macro=true";
import { default as thanksOb8RT_450OHjyOvie3UIELjaszxvSiOZJzgrSGEOjdlBsMeta } from "/var/www/frontend/releases/20260721132756/pages/thanks.vue?macro=true";
import { default as returnspfSeaTm8lVxM_4590yAdXNZ0RGth_45UuxWppOAvmrQpZzEMeta } from "/var/www/frontend/releases/20260721132756/pages/returns.vue?macro=true";
import { default as favoritesF8pncfYE_45bqCxyoz7VFy7Q7zDNMHb87vFV_E4XGV69kMeta } from "/var/www/frontend/releases/20260721132756/pages/favorites.vue?macro=true";
import { default as shopsvO6KxF_e4ikJeRW2SXFhtgl9Bo2yIzdrrJYDKtM90OsMeta } from "/var/www/frontend/releases/20260721132756/pages/help/shops.vue?macro=true";
import { default as salesrOy_5DBFeQUDF_LOQfvpJZHhv77vxKfOxjdGWM_45K_45gYMeta } from "/var/www/frontend/releases/20260721132756/pages/info/sales.vue?macro=true";
import { default as brand0vWICbCmvQ4aG0HttGh88To_klMocA1a0LJJ5__d1fsMeta } from "/var/www/frontend/releases/20260721132756/pages/about/brand.vue?macro=true";
import { default as constructorXUs6kIGHwAW_AVWdppy_45bpHkSpF0nMzejVp9MKp6j7gMeta } from "/var/www/frontend/releases/20260721132756/pages/constructor.vue?macro=true";
import { default as crafts9ZRep9Uk8xeyw9TITsmh2HvFTJaRoveYW5JzjxH7ZDoMeta } from "/var/www/frontend/releases/20260721132756/pages/about/crafts.vue?macro=true";
import { default as custom4iJEAl7nSj8cSGAskDulzzImbMHYGC6_H_454sgCW9y5QMeta } from "/var/www/frontend/releases/20260721132756/pages/about/custom.vue?macro=true";
import { default as authNc1VBbnchATRnaHmCqAz5WniFSFiUdiujTcNLwxU_PcMeta } from "/var/www/frontend/releases/20260721132756/pages/cabinet/auth.vue?macro=true";
import { default as menuS7fs6ZTnaNTY8qZ8cqml9XePSDQXqgrjOzwv_452EZX7EMeta } from "/var/www/frontend/releases/20260721132756/pages/catalog/menu.vue?macro=true";
import { default as centers4UQtvHybyIBvNSonbV6pcn6qrGBMhVWSxbOVgM1H8twMeta } from "/var/www/frontend/releases/20260721132756/pages/help/centers.vue?macro=true";
import { default as serviceE1h1EONvOiVqe9UsFLOYWYQTcNqwxHe6_84n_4594OHDEMeta } from "/var/www/frontend/releases/20260721132756/pages/help/service.vue?macro=true";
import { default as _91_46_46_46catchAll_9334nwFZU3zqoPyt53p8x9SfhhA2_VtgyXuJhfGwQ1m0AMeta } from "/var/www/frontend/releases/20260721132756/pages/[...catchAll].vue?macro=true";
import { default as historydQWMIy8oqQ03uDQ9I8DgbyCkB__G5LRSqPTlTq5LK58Meta } from "/var/www/frontend/releases/20260721132756/pages/about/history.vue?macro=true";
import { default as indexQJvs77qmye5Lehtevj0erDiWm0pwq3WbEIE_45e9HHg00Meta } from "/var/www/frontend/releases/20260721132756/pages/cabinet/index.vue?macro=true";
import { default as indexQHqgMJYe87v_T_45tv0ukToKn72Qj3esVry13mx7GAT_45UMeta } from "/var/www/frontend/releases/20260721132756/pages/catalog/index.vue?macro=true";
import { default as contactscpTeGS5hyFnxdZ6wVR4K_45SS3fM48d6SzqfM7VMRUkjcMeta } from "/var/www/frontend/releases/20260721132756/pages/help/contacts.vue?macro=true";
import { default as deliveryFdPjymA_455seAsZvSGD6SQWLDk3vq4KTfEQE1nkm1T4QMeta } from "/var/www/frontend/releases/20260721132756/pages/help/delivery.vue?macro=true";
import { default as warrantyfIEX07f11u7LPsEE_45vmEoQF8O3moanHSKYhzTNUAXjQMeta } from "/var/www/frontend/releases/20260721132756/pages/help/warranty.vue?macro=true";
import { default as cashback95BgZ16OMOhpZ4Z_jEBfweqQdAUSROavUVijys7qubsMeta } from "/var/www/frontend/releases/20260721132756/pages/info/cashback.vue?macro=true";
import { default as indexduzTxXVCNBIVo_45o__45OJRAAYkI71G7sDCQHXH8kAp5ZQMeta } from "/var/www/frontend/releases/20260721132756/pages/checkout/index.vue?macro=true";
import { default as accountEZDIymJePYsaArekBHAivrtYx2JU00rey0zMirrgF_AMeta } from "/var/www/frontend/releases/20260721132756/pages/cabinet/account.vue?macro=true";
import { default as processingCGNuue1Q51mc4_zKjQMBoEvKvQTxJ57ODUOpVaSqFl0Meta } from "/var/www/frontend/releases/20260721132756/pages/info/processing.vue?macro=true";
import { default as principles9aWBv7UV62wKVct6V7ouanm1IJEFpfaK4peBftWj1J4Meta } from "/var/www/frontend/releases/20260721132756/pages/about/principles.vue?macro=true";
import { default as cooperationo6rftjmAvOTEthgKrdmGUeQktdbtu3rYlTCNofR_Mg4Meta } from "/var/www/frontend/releases/20260721132756/pages/about/cooperation.vue?macro=true";
import { default as _91catalog_93kngaBulRbwoAIYca07wwPMoU_45ktlItaQQytbwWrUXjsMeta } from "/var/www/frontend/releases/20260721132756/pages/catalog/[catalog].vue?macro=true";
import { default as _91product_93iz_h_453riVWKqU8j7YCaWBXAfTfliQN3lhrEYCQ1b4NoMeta } from "/var/www/frontend/releases/20260721132756/pages/product/[product].vue?macro=true";
import { default as price_45listXuTRF1BPUh19_iawuXsHRRr1g6r9Ql63xbByfCXoWVYMeta } from "/var/www/frontend/releases/20260721132756/pages/cabinet/price-list.vue?macro=true";
import { default as indexg9Rwk1emmxOIUlAm_S9zT6mPLR8eqZozMOR5JNOpyvcMeta } from "/var/www/frontend/releases/20260721132756/pages/cabinet/orders/index.vue?macro=true";
import { default as _91order_93W6r9L90w7zHPYp8_45uDttzpnhYeeHwAv_VpbmIvCpXw0Meta } from "/var/www/frontend/releases/20260721132756/pages/cabinet/orders/[order].vue?macro=true";
export default [
  {
    name: "cart",
    path: "/cart",
    component: () => import("/var/www/frontend/releases/20260721132756/pages/cart.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/var/www/frontend/releases/20260721132756/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/var/www/frontend/releases/20260721132756/pages/search.vue")
  },
  {
    name: "Спасибо за заказ",
    path: "/thanks",
    meta: thanksOb8RT_450OHjyOvie3UIELjaszxvSiOZJzgrSGEOjdlBsMeta || {},
    component: () => import("/var/www/frontend/releases/20260721132756/pages/thanks.vue")
  },
  {
    name: "returns",
    path: "/returns",
    meta: returnspfSeaTm8lVxM_4590yAdXNZ0RGth_45UuxWppOAvmrQpZzEMeta || {},
    component: () => import("/var/www/frontend/releases/20260721132756/pages/returns.vue")
  },
  {
    name: "favorites",
    path: "/favorites",
    component: () => import("/var/www/frontend/releases/20260721132756/pages/favorites.vue")
  },
  {
    name: "help-shops",
    path: "/help/shops",
    meta: shopsvO6KxF_e4ikJeRW2SXFhtgl9Bo2yIzdrrJYDKtM90OsMeta || {},
    component: () => import("/var/www/frontend/releases/20260721132756/pages/help/shops.vue")
  },
  {
    name: "info-sales",
    path: "/info/sales",
    meta: salesrOy_5DBFeQUDF_LOQfvpJZHhv77vxKfOxjdGWM_45K_45gYMeta || {},
    component: () => import("/var/www/frontend/releases/20260721132756/pages/info/sales.vue")
  },
  {
    name: "about-brand",
    path: "/about/brand",
    component: () => import("/var/www/frontend/releases/20260721132756/pages/about/brand.vue")
  },
  {
    name: "constructor",
    path: "/constructor",
    component: () => import("/var/www/frontend/releases/20260721132756/pages/constructor.vue")
  },
  {
    name: "about-crafts",
    path: "/about/crafts",
    component: () => import("/var/www/frontend/releases/20260721132756/pages/about/crafts.vue")
  },
  {
    name: "about-custom",
    path: "/about/custom",
    component: () => import("/var/www/frontend/releases/20260721132756/pages/about/custom.vue")
  },
  {
    name: "auth",
    path: "/cabinet/auth",
    meta: authNc1VBbnchATRnaHmCqAz5WniFSFiUdiujTcNLwxU_PcMeta || {},
    component: () => import("/var/www/frontend/releases/20260721132756/pages/cabinet/auth.vue")
  },
  {
    name: "catalog-menu",
    path: "/catalog/menu",
    component: () => import("/var/www/frontend/releases/20260721132756/pages/catalog/menu.vue")
  },
  {
    name: "help-centers",
    path: "/help/centers",
    meta: centers4UQtvHybyIBvNSonbV6pcn6qrGBMhVWSxbOVgM1H8twMeta || {},
    component: () => import("/var/www/frontend/releases/20260721132756/pages/help/centers.vue")
  },
  {
    name: "help-service",
    path: "/help/service",
    meta: serviceE1h1EONvOiVqe9UsFLOYWYQTcNqwxHe6_84n_4594OHDEMeta || {},
    component: () => import("/var/www/frontend/releases/20260721132756/pages/help/service.vue")
  },
  {
    name: "catchAll",
    path: "/:catchAll(.*)*",
    meta: _91_46_46_46catchAll_9334nwFZU3zqoPyt53p8x9SfhhA2_VtgyXuJhfGwQ1m0AMeta || {},
    component: () => import("/var/www/frontend/releases/20260721132756/pages/[...catchAll].vue")
  },
  {
    name: "История",
    path: "/about/history",
    meta: historydQWMIy8oqQ03uDQ9I8DgbyCkB__G5LRSqPTlTq5LK58Meta || {},
    component: () => import("/var/www/frontend/releases/20260721132756/pages/about/history.vue")
  },
  {
    name: "cabinet",
    path: "/cabinet",
    component: () => import("/var/www/frontend/releases/20260721132756/pages/cabinet/index.vue")
  },
  {
    name: "catalog",
    path: "/catalog",
    component: () => import("/var/www/frontend/releases/20260721132756/pages/catalog/index.vue")
  },
  {
    name: "help-contacts",
    path: "/help/contacts",
    meta: contactscpTeGS5hyFnxdZ6wVR4K_45SS3fM48d6SzqfM7VMRUkjcMeta || {},
    component: () => import("/var/www/frontend/releases/20260721132756/pages/help/contacts.vue")
  },
  {
    name: "help-delivery",
    path: "/help/delivery",
    meta: deliveryFdPjymA_455seAsZvSGD6SQWLDk3vq4KTfEQE1nkm1T4QMeta || {},
    component: () => import("/var/www/frontend/releases/20260721132756/pages/help/delivery.vue")
  },
  {
    name: "help-warranty",
    path: "/help/warranty",
    meta: warrantyfIEX07f11u7LPsEE_45vmEoQF8O3moanHSKYhzTNUAXjQMeta || {},
    component: () => import("/var/www/frontend/releases/20260721132756/pages/help/warranty.vue")
  },
  {
    name: "info-cashback",
    path: "/info/cashback",
    meta: cashback95BgZ16OMOhpZ4Z_jEBfweqQdAUSROavUVijys7qubsMeta || {},
    component: () => import("/var/www/frontend/releases/20260721132756/pages/info/cashback.vue")
  },
  {
    name: "checkout",
    path: "/checkout",
    component: () => import("/var/www/frontend/releases/20260721132756/pages/checkout/index.vue")
  },
  {
    name: "Мой профиль",
    path: "/cabinet/account",
    meta: accountEZDIymJePYsaArekBHAivrtYx2JU00rey0zMirrgF_AMeta || {},
    component: () => import("/var/www/frontend/releases/20260721132756/pages/cabinet/account.vue")
  },
  {
    name: "info-processing",
    path: "/info/processing",
    meta: processingCGNuue1Q51mc4_zKjQMBoEvKvQTxJ57ODUOpVaSqFl0Meta || {},
    component: () => import("/var/www/frontend/releases/20260721132756/pages/info/processing.vue")
  },
  {
    name: "about-principles",
    path: "/about/principles",
    component: () => import("/var/www/frontend/releases/20260721132756/pages/about/principles.vue")
  },
  {
    name: "about-cooperation",
    path: "/about/cooperation",
    component: () => import("/var/www/frontend/releases/20260721132756/pages/about/cooperation.vue")
  },
  {
    name: "catalog-catalog",
    path: "/catalog/:catalog(.*-\\d+)",
    component: () => import("/var/www/frontend/releases/20260721132756/pages/catalog/[catalog].vue")
  },
  {
    name: "product-product",
    path: "/product/:product()",
    component: () => import("/var/www/frontend/releases/20260721132756/pages/product/[product].vue")
  },
  {
    name: "Прайс-лист",
    path: "/cabinet/price-list",
    meta: price_45listXuTRF1BPUh19_iawuXsHRRr1g6r9Ql63xbByfCXoWVYMeta || {},
    component: () => import("/var/www/frontend/releases/20260721132756/pages/cabinet/price-list.vue")
  },
  {
    name: "Мои заказы",
    path: "/cabinet/orders",
    meta: indexg9Rwk1emmxOIUlAm_S9zT6mPLR8eqZozMOR5JNOpyvcMeta || {},
    component: () => import("/var/www/frontend/releases/20260721132756/pages/cabinet/orders/index.vue")
  },
  {
    name: "Заказ",
    path: "/cabinet/orders/:order()",
    meta: _91order_93W6r9L90w7zHPYp8_45uDttzpnhYeeHwAv_VpbmIvCpXw0Meta || {},
    component: () => import("/var/www/frontend/releases/20260721132756/pages/cabinet/orders/[order].vue")
  }
]